import { Callout, ChoiceGroup, DefaultButton, IChoiceGroupOption, Icon, Label, Panel, Text, SwatchColorPicker, Image, Toggle, TooltipHost, mergeStyleSets, FontWeights, getTheme, Stack, Link, Separator, PrimaryButton } from "@fluentui/react";
import { useAppDispatch, useAppSelector } from "../../../app/Hooks";
import { getCurrentLanguage } from "../../../app/Helpers";

import { useId, useBoolean } from '@fluentui/react-hooks';
import { useEffect, useState } from "react";
import { AppTheme, ThemeManager } from "../../../app/Themes";
import { isDarkModeEnabled, isVisible,  setAppTheme, setLang } from "./NavSettingsSlice";
import i18n from "../../../app/i18n";
import { t } from "i18next";
import { setRTL } from '@fluentui/react/lib/Utilities';
import { useTranslation } from "react-i18next";
import { Popup } from "../Popup/Popup";
import { LoginForm } from "../../forms/Login/LoginForm";
import { clearSession,  getSession, isLoggedIn } from "../../../app/Api";


const colorCellsExample2 = [
    { id: 'exchange', label: 'Lochmara', color: '#0078d4' },
    { id: 'access', label: 'Stiletto', color: '#a4373a' },
    { id: 'excel', label: 'Green Pea', color: '#217346' },
    { id: 'office', label: 'Grenadier', color: '#d83b01' },
    { id: 'oneNote', label: 'Seance', color: '#7719aa' },
    { id: 'planner', label: 'Goblin', color: '#31752f' },
    { id: 'powerApps', label: 'Plum', color: '#742774' },
    { id: 'powerPoint', label: 'Tuscany', color: '#b7472a' },
    { id: 'publisher', label: 'Elf Green', color: '#077568' },
    { id: 'sway', label: 'Deep Sea', color: '#008272' },
    { id: 'teams', label: 'Scampi', color: '#6264a7' },
    { id: 'visio', label: 'Azure', color: '#3955a3' },
    { id: 'word', label: 'St Tropaz', color: '#2b579a' },
    { id: 'yammer', label: 'Denim', color: '#106EBE' },
    { id: 'basic', label: 'Silver', color: '#595959' },
    { id: 'black', label: 'Black', color: '#323130', },
];

const options: IChoiceGroupOption[] = [
    {
        key: 'ar',
        iconProps: { iconName: 'LocaleLanguage', },
        text: 'العربية',
    },
    {
        key: 'en',
        iconProps: { iconName: 'LocaleLanguage' },
        text: 'English',
    },
];


export const NavSettings: React.FunctionComponent = () => {
    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);

    const dispatch = useAppDispatch()
    const colorBaseId = useId('color-picker');
    const langBaseId = useId('lang-picker');
    const labelId = useId('callout-label');
    const { t, i18n } = useTranslation()
    const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);

    const state: { isVisible: boolean, appTheme: string, isDarkModeEnabled: boolean, currentLang: string } = useAppSelector((state) => {
        return { isVisible: state.settings.isVisible, appTheme: state.settings.appTheme, isDarkModeEnabled: state.settings.isDarkModeEnabled, currentLang: state.settings.currentLang };
    })

    const [isSignedIn, setIsSignedIn] = useState(isLoggedIn());
    const swatchColorPickerOnCellHovered = (id?: string | undefined, color?: string | undefined) => {
        if (id) {
            dispatch(setAppTheme(id))
        }
        else {
            dispatch(setAppTheme(ThemeManager.getThemeManager().getTheme().themeId))
        }
    };

    const swatchColorPickerOnCellClicked = (id?: string | undefined, color?: string | undefined) => {
        if (id) {
            changeTheme(ThemeManager.getThemeManager().getTheme(id, state.isDarkModeEnabled));
        }
    };
    const changeLang = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {
        if (option) {
            localStorage.setItem("lang", option.key);
            //dispatch(setLang(option.key))
            // i18n.changeLanguage(option.key)
            // setRTL(option.key == 'ar');
            window.location.reload();
        }
    };
    const changeTheme = (appTheme: AppTheme) => {
        dispatch(setAppTheme(appTheme.themeId))
        dispatch(isDarkModeEnabled(appTheme.isDarkModeEnabled))
        ThemeManager.getThemeManager().applyTheme(appTheme)
    }


    return (
        <Panel
            headerText={t("settings")}
            // this prop makes the panel non-modal
            isBlocking={false}
            isOpen={state.isVisible}
            onDismiss={() => dispatch(isVisible(false))}
            closeButtonAriaLabel={t("close")}

        >
            <ChoiceGroup id={langBaseId} label={t("langauge")} defaultSelectedKey={state.currentLang} options={options} onChange={changeLang} />

            <Popup isOpen={isModalOpen} title={t("signin")} onDismiss={hideModal} >
                <LoginForm childrenGap={10} maxWidth={500} onCancel={hideModal} onSuccess={(e) => {

                    window.location.href = "/";

                }} />
            </Popup>
            <Toggle
                checked={state.isDarkModeEnabled}
                label={
                    <div>
                        {t("darkMode") + ' '}
                        <TooltipHost content={t("darkModeLabel")}>
                            <Icon iconName="Info" aria-label={t("darkModeLabel")} />
                        </TooltipHost>
                    </div>
                }
                onText={t("enabled")}
                offText={t("disabled")}
                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => { changeTheme(ThemeManager.getThemeManager().getTheme(state.appTheme, checked)) }}
            />

            <Stack tokens={{ childrenGap: 8, padding: 8 }} horizontalAlign="center">


                <Link target="_blank" styles={{ root: { fontSize: 18 } }} href="https://sanadapp.ly" >
                    {t("sanadTitle")}
                </Link>
                <Text>{t("sanadDesc")}</Text>
            </Stack>

            <Stack tokens={{ childrenGap: 8, padding: 8 }} horizontalAlign="center">
                {isSignedIn ? <PrimaryButton onClick={() => {
                    clearSession();
                    window.location.href = "/";
                }} styles={{ root: { borderRadius: 12, width: "20%", minWidth: 150 } }} text={t("logout")}></PrimaryButton>

                    : <PrimaryButton onClick={showModal} styles={{ root: { borderRadius: 12, width: "20%", minWidth: 150 } }} text={t("signin")}></PrimaryButton>
                }
            </Stack>
            <Separator alignContent="start"><b>{t("noAccount")}</b></Separator>


            <Stack tokens={{ childrenGap: 8, padding: 8 }} horizontalAlign="center">



                <Stack horizontalAlign="center" horizontal>
                    <Link styles={{ root: { width: "50%" } }} target="_blank" href='https://play.google.com/store/apps/details?id=ly.devpoint.sanad&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
                        <Image styles={{ image: { width: "100%" } }} alt='احصل عليه من Google Play' src={'https://play.google.com/intl/en_us/badges/static/images/badges/' + (getCurrentLanguage()) + '_badge_web_generic.png'} />
                    </Link>
                    <Link styles={{ root: { width: "50%" } }} target="_blank" href="https://apps.apple.com/ly/app/sanad-%D8%B3-%D9%86%D8%AF/id6460253495?itsct=apps_box_badge&amp;itscg=30200">

                        <Image styles={{ image: { width: "100%" } }} src={"https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/" + (getCurrentLanguage() == "ar" ? "ar-ar" : "en-us") + "?size=250x83&amp;releaseDate=1692921600"} alt="Download on the App Store" /></Link>
                </Stack>
            </Stack>
        </Panel>

    )
};
